module.exports = __webpack_public_path__ + "img/ic_food_manage_bottom_item_img4.9cee4ec1.png";